export const isPositiveMoney = (value) => /^\d+(\.\d{1,2})?$/.test(String(value))
  && Number(value) > 0 && Number(value) <= 9999999999.99;

export function storedValueFormErrors(form, now = Date.now()) {
  const errors = {};
  if (!Number.isInteger(Number(form.clientId)) || Number(form.clientId) <= 0) errors.clientId = 'clientRequired';
  if (!isPositiveMoney(form.initialValue)) errors.initialValue = 'invalidAmount';
  if (form.type === 'VALUE_VOUCHER') {
    if (!String(form.motivation || '').trim()) errors.motivation = 'motivationRequired';
    if (String(form.motivation || '').trim().length > 500) errors.motivation = 'textTooLong';
    if (String(form.authorization || '').trim().length > 500) errors.authorization = 'textTooLong';
    if (!form.expiresAt) errors.expiresAt = 'expiryRequired';
  }
  if (form.expiresAt && (!Number.isFinite(new Date(form.expiresAt).getTime())
    || new Date(form.expiresAt).getTime() <= now)) errors.expiresAt = 'futureExpiry';
  return errors;
}
